var ResourceData = {}

jQuery(document).ready(function() {
  if(!jQuery('.settings-content').length) return
  ResourceData.fetchingResources = false
  bindSettingsPage()
})

function bindSettingsPage() {
  fetchAccountsList()
  fetchDocuments()
  fetchPaymentProfiles()
  bindIndividualSettingsDetailsPanel()
  document.dispatchEvent(new CustomEvent('client-settings-page-loaded'))
  try {
    bindResourceTableFilter()
  } catch (e) {
    console.error('unable to load resource table filters', e)
  }
}



function bindResourceTableFilter() {
  var resourceTypeFilter = new TableFilter({
    filterSelector: jQuery('#resource_type_filter'),
    popoverSelector: jQuery('#resource_type_popover'),
    filterContainer: '.resource-type-popover',
    filterCallback: fetchResources,
  }).init()
  ResourceData.resourceTypeFilter = resourceTypeFilter
}

function fetchResources() {
  if (!ResourceData.fetchingResources) {
    ResourceData.fetchingResources = true
    jQuery.ajax({
      url: jQuery('#resource-content').data('source'),
      type: "GET",
      dataType: 'script',
      data: {
        resource_types: ResourceData.resourceTypeFilter.selectedTableFilters(),
      },
      success: function() {
        ResourceData.fetchingResources = false
      },
    })
  }
}

function fetchDocuments() {
  jQuery.ajax({
    url: jQuery('#resource-content').data('source'),
    type: 'GET',
  })
}
function fetchAccountsList() {
  jQuery.ajax({
    url: jQuery('.accounts-list').data('source'),
    type: 'GET',
  })
}

function fetchPaymentProfiles() {
  jQuery.ajax({
    url: jQuery('#payment-profiles').data('source'),
    type: 'GET',
  })
}

function bindOpenCloseAccountList() {
  jQuery('.accounts-list-toggle').click(function() {
    var button = jQuery(this)
    if (button.text() == "Open All") {
      jQuery('.region-toggle.fa-chevron-down').each(function() {
        var regionToggler = jQuery(this)
        var regionId = regionToggler.attr('data-region-id')
        regionToggler.removeClass('fa-chevron-down')
        regionToggler.addClass('fa-chevron-up')
        jQuery('.region-' + regionId).removeClass('d-none')
      })
      jQuery('.accounts-list-toggle').text("Close All")
    } else {
      jQuery('.region-toggle.fa-chevron-up').each(function() {
        var regionToggler = jQuery(this)
        var regionId = regionToggler.attr('data-region-id')
        regionToggler.removeClass('fa-chevron-up')
        regionToggler.addClass('fa-chevron-down')
        jQuery('.region-' + regionId).addClass('d-none')
      })
      jQuery('.accounts-list-toggle').text("Open All")
    }
  })
}

function bindRegionToggle() {
  jQuery('.region-toggle').click(function() {
    var regionId = jQuery(this).attr('data-region-id')
    if (jQuery(this).hasClass('fa-chevron-up')) {
      jQuery('.region-toggle-' + regionId).removeClass('fa-chevron-up')
      jQuery('.region-toggle-' + regionId).addClass('fa-chevron-down')
      jQuery('.region-' + regionId).addClass('d-none')
      if (jQuery('.region-toggle.fa-chevron-up').length == 0) jQuery('.accounts-list-toggle').text("Open All")
    } else {
      jQuery('.region-toggle-' + regionId).removeClass('fa-chevron-down')
      jQuery('.region-toggle-' + regionId).addClass('fa-chevron-up')
      jQuery('.region-' + regionId).removeClass('d-none')
      if (jQuery('.region-toggle.fa-chevron-down').length == 0) jQuery('.accounts-list-toggle').text("Close All")
    }
  })
}

function bindIndividualSettingsDetailsPanel() {
  bindShowIndividualAccountDetailsPanel()
  bindCloseIndividualSettingsDetails()
  bindEditAccountDeliveryInstructions()
  bindShowIndividualMembershipDetailsPanel()
}

function bindShowIndividualAccountDetailsPanel() {
  jQuery('html').on('click', '.show-individual-account-details', function() {
    var $account = jQuery(this)
    jQuery('#individual_account_details_market').text($account.attr('data-market'))
    jQuery('#individual_account_details_market').attr('title', $account.attr('data-market'))
    jQuery('#individual_account_details_building').text($account.attr('data-building'))
    jQuery('#individual_account_details_building').attr('title', $account.attr('data-building'))
    jQuery('#individual_account_details_account').text($account.attr('data-account-name'))
    jQuery('#individual_account_details_account').attr('title', $account.attr('data-account-name'))
    jQuery('#individual_account_details_address1').text($account.attr('data-address1'))
    jQuery('#individual_account_details_address2').text($account.attr('data-address2'))
    jQuery('#individual_account_details_city').text($account.attr('data-city'))
    jQuery('#individual_account_details_state').text($account.attr('data-state'))
    jQuery('#individual_account_details_zip').text($account.attr('data-zip'))
    jQuery('#individual_account_details_instructions').val($account.attr('data-instructions'))
    jQuery('#individual_account_details_instructions').text($account.attr('data-instructions'))
    jQuery('#individual_account_details_instructions').attr('data-source', $account.attr('data-update-instructions-source'))
    jQuery('#individual_account_details_instructions').attr('data-previous', $account.attr('data-instructions'))
    jQuery('#account_payment_profiles').html("<progress-ring radius='30' progress='0'></progress-ring>")
    jQuery.ajax({
      url: $account.attr('data-account-payment-profiles-source'),
      type: 'GET',
    })

    showIndividualAccountDetailsPanel()
  })
}

function bindEditAccountDeliveryInstructions() {
  jQuery('html').on('click', '#individual_account_details_edit_instructions_btn', function() {
    jQuery('#individual_account_details_edit_instructions_btn').addClass('hidden')
    jQuery('#individual_account_details_instructions').attr('disabled', false)
    bindUpdateAccountDeliveryInstructions()
  })
}

function bindUpdateAccountDeliveryInstructions() {
  jQuery('#individual_account_details_instructions').unbind('keydown')
  jQuery('#individual_account_details_instructions').unbind('focusout')

  jQuery('#individual_account_details_instructions').keydown(function(e) {
    if (e.keyCode == 13) {
      e.preventDefault()
      updateAccountDeliveryInstructions()
    }
  })

  jQuery('#individual_account_details_instructions').focusout(function() {
    updateAccountDeliveryInstructions()
  })
}

function updateAccountDeliveryInstructions() {
  var instructions = jQuery('#individual_account_details_instructions').val()
  var previousInstructions = jQuery('#individual_account_details_instructions').attr('data-previous')

  if (instructions != previousInstructions) {
    jQuery('#individual_account_details_instructions').attr('data-previous', instructions)

    jQuery.ajax({
      url: jQuery('#individual_account_details_instructions').attr('data-source'),
      type: 'PATCH',
      data: {
        instructions: instructions,
      },
    })
  } else {
    jQuery('#individual_account_details_edit_instructions_btn').removeClass('hidden')
    jQuery('#individual_account_details_instructions').attr('disabled', true)
  }
}

function bindShowIndividualMembershipDetailsPanel() {
  jQuery('html').on('click', '.show-individual-membership-details', function() {
    var $buildingMembership = jQuery(this)
    jQuery('#individual_membership_details_market').text($buildingMembership.attr('data-market'))
    jQuery('#individual_membership_details_market').attr('title', $buildingMembership.attr('data-market'))
    jQuery('#individual_membership_details_building_name').text($buildingMembership.attr('data-building'))
    jQuery('#individual_membership_details_building_name').attr('title', $buildingMembership.attr('data-building'))
    jQuery('#individual_membership_details_address1').text($buildingMembership.attr('data-address1'))
    jQuery('#individual_membership_details_address2').text($buildingMembership.attr('data-address2'))
    jQuery('#individual_membership_details_city').text($buildingMembership.attr('data-city'))
    jQuery('#individual_membership_details_state').text($buildingMembership.attr('data-state'))
    jQuery('#individual_membership_details_zip').text($buildingMembership.attr('data-zip'))
    jQuery('#individual_membership_details_building_email').text($buildingMembership.attr('data-building-email'))
    jQuery('#individual_membership_details_service_type').text($buildingMembership.attr('data-service-type'))

    showIndividualMembershipDetailsPanel()
  })
}

function showIndividualAccountDetailsPanel() {
  jQuery('.panel-wrapper-settings').removeClass('hidden')
  jQuery("#individual_account_details_panel").animate({ width: '100%' }, 250)
  jQuery('#full-backdrop').removeClass('hidden')
}

function showIndividualMembershipDetailsPanel() {
  jQuery('.panel-wrapper-settings').removeClass('hidden')
  jQuery("#individual_membership_details_panel").animate({ width: '100%' }, 250)
  jQuery('#full-backdrop').removeClass('hidden')
}

function hideIndividualSettingsDetailsPanel() {
  if (jQuery("#individual_account_details_panel").width() > 0) {
    jQuery("#individual_account_details_panel").animate({ width: '0' }, 250)
  } else {
    jQuery("#individual_membership_details_panel").animate({ width: '0' }, 250)
    jQuery('.membership-details').addClass('hidden')
    jQuery('.form-placeholder').slideUp()
    jQuery('.membership-body-details').slideDown()
  }

  delay(function() {
    jQuery('.panel-wrapper').addClass('hidden')
    jQuery('#full-backdrop').addClass('hidden')
  }, 100)
}

function bindCloseIndividualSettingsDetails() {
  jQuery('html').on('click', '.close-details', function() {
    hideIndividualSettingsDetailsPanel()
  })

  jQuery('html').on('click', '#full-backdrop', function() {
    hideIndividualSettingsDetailsPanel()
  })
}

function bindPaymentProfiles() {
  bindShowPaymentProfileDropdown()
  bindHidePaymentProfileDropdown()
}

function bindShowPaymentProfileDropdown() {
  jQuery('.profile-dropdowns .collapse').unbind('show.bs.collapse')

  jQuery('.profile-dropdowns .collapse').on('show.bs.collapse', function() {
    var dropdown = jQuery(this)
    var dropdownContainer = dropdown.parent('.profile-dropdowns')
    var profileId = dropdownContainer.attr('data-id')
    var profileCard = jQuery('#payment_profile_card_' + profileId)
    jQuery('.profile-dropdowns .collapse').collapse('hide')
    jQuery('.payment-profile.active').removeClass('active')
    jQuery('.profile-dropdowns.active').removeClass('active')
    dropdownContainer.addClass('active')
    profileCard.addClass('active')
  })
}

function bindHidePaymentProfileDropdown() {
  jQuery('.profile-dropdowns .collapse').unbind('hide.bs.collapse')

  jQuery('.profile-dropdowns .collapse').on('hide.bs.collapse', function() {
    var dropdown = jQuery(this)
    var dropdownContainer = dropdown.parent('.profile-dropdowns')
    var profileId = dropdownContainer.attr('data-id')
    var profileCard = jQuery('#payment_profile_card_' + profileId)
    dropdownContainer.removeClass('active')
    profileCard.removeClass('active')
  })
}

window.bindOpenCloseAccountList = bindOpenCloseAccountList
window.bindPaymentProfiles = bindPaymentProfiles
window.bindRegionToggle = bindRegionToggle
window.bindSettingsPage = bindSettingsPage
